import { Component, OnInit } from '@angular/core';
import { app_version } from './../../../environments/version';

import { VersionService } from './../../services/index';
import { CommonService } from './../../services/index';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent implements OnInit {
  version: string;
  ewdapi_version: string;
  transportapi_version: string;
  emailapi_version: string;
  today: string;

  constructor(
    private versionService: VersionService
  ) { }

  ngOnInit() {
    this.version = app_version;
    this.ewdapi_version = "";
    this.transportapi_version = "";
    this.emailapi_version = "";
    this.today = CommonService.dateFormatted(new Date());

    this.versionService.getEWDVersion().subscribe(
      (version: string) => {
        this.ewdapi_version = version;
      },
    );

    this.versionService.getTransportApiVersion().subscribe(
      (version: string) => {
        this.transportapi_version = version;
      },
    );

    this.versionService.getEmailApiVersion().subscribe(
      (version: string) => {
        this.emailapi_version = version;
      },
    );

    // do the things above
  }

}
